import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastError } from "../../Helper/ToastMessage";

// Get Table Data
export const GroupAttendanceGetTableDataAPI = createAsyncThunk("GroupAttendanceGetTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_ZoneID,
        T_Encroach_GroupAttendanceID,
        M_WorkTypeID,
        Language,
        M_UserID,
        FromTop,
        ToTop,
        token,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Dashboard/Get_WEB_T_Encroach_GroupAttendance_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID}&T_Encroach_GroupAttendanceID=${T_Encroach_GroupAttendanceID}&M_WorkTypeID=${M_WorkTypeID}&Language=${Language}&Flag=${Flag}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data && result.data.table) {
                    return result.data.table
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const GroupAttendanceGetTableDataSlice = createSlice({
    name: "GroupAttendanceGetTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GroupAttendanceGetTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GroupAttendanceGetTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(GroupAttendanceGetTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const GroupAttendanceGetTableDataReducer = GroupAttendanceGetTableDataSlice.reducer